import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BorderPicker } from 'components/MarkupDetails/ColorPicker'
import WiringPanel from 'components/WiringPanel'
import Panel from 'components/Panel'
import DeviceDescription from 'components/DeviceDescription'
import VideoPanel from 'components/VideoPanel'
import { updateUiAction } from 'actions/uiActions'
import { updateWiredDeviceAction, changeWiredDeviceTypeAction, deleteWiredDeviceAction, removeDeviceWiresAction } from 'actions/entityActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'
import { messageAction } from 'actions/messageActions'
import getTypeIconString from 'helpers/wiredDevices/getTypeIconString'
import { WIRED_DEVICE_TYPES, COPY_ICON_STACK } from 'helpers/globals'
import tippy from 'tippy.js'

const mapStateToProps = state => {
  const { entities: { wiredDevices: { byId } }, currentEntity: { id }, map: { ref }, ui: { cameraDescriptionPanelOpen } } = state

  return {
    currentWiredDevice: byId[id],
    map: ref,
    cameraDescriptionPanelOpen
  }
}

class WiredDeviceDetails extends React.Component {
  componentDidMount = _ => tippy(`.${this.props.classes.type}`, { duration: 0, theme: 'topbar', placement: 'top' })

  handleTypeChange = newType => _ => {
    const { currentWiredDevice: { id, type }, changeWiredDeviceTypeAction } = this.props

    if (type !== newType) changeWiredDeviceTypeAction(id, newType)
  }

  render() {
    const { currentWiredDevice, map, cameraDescriptionPanelOpen, updateUiAction, messageAction, removeDeviceWiresAction,
      updateWiredDeviceAction, deleteWiredDeviceAction, checkOfflineLimitsAction, classes } = this.props
    const { id, locked, name, nameTouched, location, type, color, manufacturer, model } = currentWiredDevice

    return (
      <div className={classes.details}>
        <div className={classes.topUiControls}>
          <a onClick={_ => updateUiAction({ sidebarView: 'cameraList' })}>
            <FontAwesomeIcon icon='caret-left' className={classes.goBackButton} />
            All Project Items
          </a>
          <a
            onClick={_ => {
              if (locked) {
                messageAction('generalError', `Cannot delete locked ${type}. Right click to unlock.`)
              } else if (window.confirm(`Are you sure you want to delete ${name}?`)) {
                removeDeviceWiresAction(id, 'wiredDevice')
                deleteWiredDeviceAction(id)
              }
            }}
            className={classes.destroyButton}>
            <FontAwesomeIcon icon={['far', 'trash-alt']} />
          </a>
        </div>
        <div className={classes.container}>
          <div title='Name' className={classes.label}>Name</div>
          <input
            type='text'
            onChange={({ target: { value } }) => {
              updateWiredDeviceAction(id, Object.assign({}, { name: value }, !nameTouched && { nameTouched: true }))
            }}
            value={name || ''}
          />
          <div className={classes.actions}>
            <a
              onClick={_ => checkOfflineLimitsAction('duplicateWiredDevice', [id])}
              title={`Duplicate ${type}`}
            >
              {COPY_ICON_STACK}
            </a>
            <a onClick={_ => map.panTo(location)}>
              <FontAwesomeIcon icon='map-marker-alt' />
            </a>
            <a onClick={_ => updateWiredDeviceAction(id, { locked: !locked })}>
              <FontAwesomeIcon icon={locked ? 'lock' : 'unlock'} />
            </a>
          </div>
        </div>
        <div className={classes.container}>
          <span className={classes.colorLabel}>Color</span>
          <BorderPicker
            currentMarkup={{ id, type: 'wiredDevice', strokeColor: color }}
            updateMarkupAction={(id, action) => updateWiredDeviceAction(id, { color: action.strokeColor })}
            cameraOnly
          />
        </div>
        <div className={classes.container}>
          <span className={classes.colorLabel}>Type</span>
          <div className={classes.typesContainer}>
            { WIRED_DEVICE_TYPES.map(({ text, value }) =>
                <div
                  style={{ background: type === value ? color : 'white', color: type === value ? 'white' : color }}
                  onClick={this.handleTypeChange(value)}
                  className={classes.type}
                  title={text}
                  key={value}
                >
                  <FontAwesomeIcon icon={getTypeIconString(value)} style={{ margin: 'auto' }} />
                </div>
              )
            }
          </div>
        </div>
        <div className={classes.container}>
          <span className={classes.otherLabel}>Manufacturer</span>
          <input
            type='text'
            className={classes.input}
            onChange={({ target: { value } }) => updateWiredDeviceAction(id, { manufacturer: value })}
            value={manufacturer || ''}
          />
        </div>
        <div className={classes.container}>
          <span className={classes.otherLabel}>Model</span>
          <input
            type='text'
            className={classes.input}
            onChange={({ target: { value } }) => updateWiredDeviceAction(id, { model: value })}
            value={model || ''}
          />
        </div>
        <div className={classes.container}>
          <WiringPanel startDevice={currentWiredDevice} startDeviceType='wiredDevice' />
        </div>
        <Panel
          active={cameraDescriptionPanelOpen}
          component={<DeviceDescription currentDevice={currentWiredDevice} type='wiredDevice' />}
          title='Location, Description, Notes'
          updateUiAction={updateUiAction}
          uiKey='cameraDescriptionPanelOpen'
        />
        <VideoPanel
          videoUrl='https://www.youtube.com/embed/xpoUAlnYmCc?rel=0&showinfo=0'
          uiKey='wiredDeviceVideoPanelOpen'
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction, updateWiredDeviceAction, changeWiredDeviceTypeAction, deleteWiredDeviceAction,
  removeDeviceWiresAction, checkOfflineLimitsAction, messageAction })(injectSheet(style)(WiredDeviceDetails))



// WEBPACK FOOTER //
// ./src/components/WiredDeviceDetails/index.js